<template>
  <div
    class="form-section-highlight"
    :style="cssStyles"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'form-section-highlight',
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    cssStyles () {
      if (this.color) {
        return {
          borderLeftColor: this.color,
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.form-section-highlight {
  border-left: 8px solid rgba(var(--v-primary-rgb, $clr-primary-rgb), 0.5);
  padding-left: 20px;

  @media screen and (min-width: 768px) {
    padding-left: 35px;
  }

  @media screen and (min-width: 992px) {
    padding-left: 85px;
  }
}
</style>
